<template>
  <div class="rew18_goodsList_wrap rew18_basketBottom">
    <div v-if="isNuskinChannel"
      class="rew18_payment_list-total rew18_payment_list-total--border">
      총 <strong class="aroCnt">{{$fmt.PDCnt(productList.length)}}</strong>개
    </div>

    <div :class="{shop : isNuskinChannel}" class="rew19_aro_wrap">
      <div class="rew19_goodsList_wrap">

        <div v-if="!productList || productList.length <= 0"
          class="rew19_noData_wrap noIcon">
          <span class="rew19_noData">검색 결과가 없습니다.</span>
        </div>

        <ul class="rew19_goodsList rew19_clear">
          <li v-for="(product, idx) in productList" v-bind:key="idx">
            <a class="rew19_aProduct"
              @click="onClickMoveProductDetail(product, idx)">
              <div class="rew19_goodsWrap">
                <div class="rew19_goodsImg">
                  <span class="rew18_goodsDim" v-if="product.isSoldOut == 'Y'">
									  <em>일시품절</em>
									</span>
                  <i v-if="product.isRetention == 'Y'"
                    class="rew19_goodsFlag fourplus">4+1</i>
                  <span class="rew19_rateImg">
                    <img
                      :src="product.pd_img_url1"
                      :alt="product.pd_id"
                      onError="imageError(this)" data-error-cnt="0"
                    />
                  </span>
                </div>
                <button type="button" @click.stop.prevent="onClickAddCart(product, product.division_code)" class="rew19_btn_putB">
                  <span class="rew19_icon_busk">장바구니 담기</span>
                </button>
              </div>
              <p class="rew19_goodsTxt">{{product.pd_name_kr}}</p>
              <p class="rew19_goodsPrice m">
                <em class="rew19_gTit">정기구매가</em>
                <span class="rew19_gDetail">
                  <strong>{{$fmt.WON(product.pd_amt1)}}</strong>원
                </span>
              </p>
              <p class="rew19_goodsPrice p">
                <em class="rew19_gTit">회원가</em>
                <span class="rew19_gDetail">{{$fmt.WON(product.membersPrice)}}원</span>
              </p>
            </a>
          </li>
        </ul>

        <div class="rew19_basket_wrap">
          <div class="rew19_basket_center">
            <div class="rew19_basket_rate">
              <ul class="rew19_basket_detail">
                <li class="rew19_basket_su">
                  <em>수량</em>
                  <span class="rew19_point">{{$fmt.PDCnt(cartInfo["basketCount"])}}</span>
                  <span class="rew19_unit">개</span>
                </li>
                <li v-if="getMemberType() == 'DIST'"
                  class="rew19_basket_pv">
                  <em>SV</em>
                  <span class="rew19_money">{{$fmt.PV(cartInfo["total_pv"])}}</span>
                </li>
                <li class="rew19_basket_sum">
                  <span class="rew19_point">{{$fmt.WON(cartInfo["payment_amt"])}}</span>
                  <span class="rew19_unit">원</span>
                </li>
              </ul>
            </div>
            <a @click="onClickMoveBasket" class="rew19_basket_oder">
              <span>신규 정기구매 장바구니</span>
            </a>
          </div>
          <!--//rew19_basket_center-->
        </div>
        <!--//rew19_basket_wrap-->
      </div>
      <!--//rew19_goodsList_wrap-->
      <cart-added-popup :show="showCartAdded"></cart-added-popup>
      <cart-add-dialog
        ref="cartAddDialog"
        :show="cartAddDialogShow"
        :data='cartAddDialog'
        @close='onCloseCartAddDialog'></cart-add-dialog>
    </div>
    <!--rew19_aro_wrap-->
  </div>
</template>
<script>
import AroBase from '@/components/base/AroBase';
import CartAddedPopup from '@/components/popup/CartAdded';
import CartAddDialog from '@/components/popup/CartAddDialog';
import * as Const from "@/utils/const";
import * as ErrMsg from "@/utils/error_msg";

export default {
  name: "productList",
  extends: AroBase,
  components: { CartAddedPopup, CartAddDialog },
  computed: {
    isNuskinChannel : function() {
      return this.$aroChannel == Const.ARO_CHANNEL_NUSKIN;
    }
  },
  props:{
    division_code: {
      type: String,
      default: "N"
    },
    big_classcodes: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    //View Data
    productList: [
      // {
      //   pd_id: "",
      //   pd_name_kr: "",
      //   pd_amt: "",
      //   pd_amt1: "",
      //   pd_img_url1: ""
      // }
    ],

    params : {
      division_code: "N",
      big_classcodes: "",
      search_typ: "",
      search_key: ""
    },

    showCartAdded : false,
    cartInfo : {
      basketCount : 0,
      pd_count : 0,
      total_pv : "0.00",
      payment_amt : 0,
      uspan_pd_count : 0,
      uspan_total_pv : "0.00",
      uspan_payment_amt : 0,
    },
    cartAddDialogShow : false,
    cartAddDialog : {
      rawData : {
        countPerPage: 5,
        page: 1,
        totalCount: 0,
        //...
      },
      resData : {
        addTo : "CART", //장바구니:CART, aro_no:기존Aro에 추가
        aroData : null,
      }
    },

    gaTitle : "정기구매_검색",
    testText : ""
  }),
  created() {
    let _this = this;
  },
  mounted() {
    let _this = this;

    _this.initUI();

    _this.loadData();
  },

  beforeDestroy() {
  },
  watch:{
    //라우터 변경 이벤트
    $route (to, from){
      let _this = this;

      _this.loadData();

      //Aro UI
      _this.initUI();
    }
  },
  methods: {
    /**
     * JQuery UI
     */
    initUI : function(){

    },

    /**
     * API Request
     */
    //상품목록 가져오기
    apiGetProductList : function() {
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/product/list`, {
        params: {
          search_typ: "S",
          search_key: searchValue
        }
      });
    },

    //장바구니 정보 가져오기
    apiGetCart : function(){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_cart`, {
        params: {}
      });
    },

    //장바구니에 상품 추가
    apiAddProductInCart : function(pd_id, pd_count, division_code){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count,
          division_code : division_code
        }
      ];

     return _this.$http.get(`${_this.$aroApiBasePath}/aro/put_cart`, {
        params: {
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },

    //나의 ARO 정보 가져오기
    apiGetAro : function(pageNo){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/get_aro`, {
        params: {
          isUspan : "N",
          page : pageNo,
          countPerPage : _this.cartAddDialog.rawData.countPerPage
        }
      });
    },

    //ARO 변경 가능 여부 체크
    apiCheckAroModifyStatus : function(aro_no){
      let _this = this;

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/modify_status`, {
        params: {
          adpNo : aro_no
        }
      });
    },

    //나의 ARO에 상품 추가
    apiAddProductInAro : function(aro_no, pd_id, pd_count){
      let _this = this;

      let pdAddList = [
        {
          pd_id : pd_id,
          pd_count : pd_count
        }
      ];

      return _this.$http.get(`${_this.$aroApiBasePath}/aro/add_products`, {
        params: {
          aro_no : aro_no,
          pd_add_list : JSON.stringify(pdAddList)
        },
        paramsSerializer: function (params) {
          return require('qs').stringify(params, {arrayFormat: 'brackets'})
        },
      });
    },


    /**
     * Local function
     */
    //데이터 로드
    loadData : function(){
      let _this = this;

      //상품로드
      _this.loadList(_this.division_code, _this.big_classcodes);

      // 장바구니 정보 로드
      if(_this.isLogined()){
        _this.loadCartInfo();
      }
    },

    //상품로드(초기)
    loadList : function(divisionCode, bigClasscodes) {
      let _this = this;

      //show loading
      _this.$showLoading();
      _this.apiGetProductList().then(prodListRes=>{

        if (prodListRes.status === 200 && prodListRes.data.status === "0000") {
          _this.productList = [...prodListRes.data.pd_list];
        }

      }).catch(()=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();

        //GA 전송-상품 목록
        try{
          _this.sendGaProductList();
        }catch(e){
          //ignore
          console.error(e);
        }
      });
    },

    /**
     * 장바구니 관련
     */
    //장바구니 정보 로드
    loadCartInfo : function(){
      let _this = this;
      _this.$showLoading();
      _this.apiGetCart().then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.cartInfo = {...res.data};
        }
      }).catch((err)=>{
        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        //hide loading
        _this.$hideLoading();
      });
    },

    //장바구니 추가
    onClickAddCart : function(product, division_code){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      if(product.isSoldOut == 'Y'){
         _this.$dialogs.alert('품절된 상품입니다.').then(res => {});
        return;
      }

      //GA 전송-장바구니 클릭
      try{
        _this.sendGaProductToCart(product, 1);
      }catch(e){
        //ignore
        console.error(e);
      }

      let pd_id = product.pd_id;
      let reqPageNo = 1;
      _this.$showLoading();
      _this.apiGetAro(reqPageNo).then(res=>{

        if (res.status === 200 && res.data.status === "0000") {
          _this.cartAddDialog.rawData = res.data;

          if(!_this.cartAddDialog.rawData.totalCount || _this.cartAddDialog.rawData.totalCount <= 0){
            // ARO내역이 없으면, 바로 장바구니에 추가
            return _this.apiAddProductInCart(pd_id, 1, division_code);
          }

          //정기구매 선택 Dialog 표시
          _this.cartAddDialog.targetProduct = {
            pd_id : pd_id, division_code : division_code
          };
          _this.$refs.cartAddDialog.initData();
          _this.cartAddDialogShow = true;
        }else{
          //console.error(res);
          let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
          _this.$dialogs.alert(errMsg)
          .then(res => {});
        }

        return null;
      }).then(res=>{
        if(res){
          if (res.status === 200 && res.data.status === "0000") {
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 로드
            _this.loadCartInfo();

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }
      }).catch((err)=>{
        console.error(err);

        _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
        .then(res => {});

      }).finally(()=>{
        _this.$hideLoading();
      });
    },

    //장바구니 다이얼로그 처리
    onCloseCartAddDialog(isOk, data) {
      let _this = this;
      _this.cartAddDialogShow = false;

      if(!isOk){
        //Do nothing.
        return;
      }

      //장바구니 직접등록 or 기존 aro 에 추가
      let retData = data;

      let pd_id = _this.cartAddDialog.targetProduct.pd_id;
      let division_code = _this.cartAddDialog.targetProduct.division_code;
      let pd_count = 1;
      let targetAro = retData.resData.aroData;

      if(retData.resData.addTo === "CART"){
        //장바구니에 추가
        _this.$showLoading();
        _this.apiAddProductInCart(pd_id, pd_count, division_code).then((res)=>{
          if (res.status === 200 && res.data.status === "0000"){
            //장바구니에 추가 popup
            _this.showCartAdded = true;
            setTimeout(()=>{
              _this.showCartAdded = false;
            }, 1000);

            //장바구니 로드
            _this.loadCartInfo();

            //장바구니 변경 handler
            _this.$changeBasketCount();
          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });

      }else{
        //기존 ARO에 추가
        _this.$showLoading();
        _this.apiCheckAroModifyStatus(retData.resData.addTo).then((res)=>{
          if (res.status === 200 && res.data.status === "0000") {
            return _this.apiAddProductInAro(retData.resData.addTo, pd_id, pd_count);

          }else{
            //console.error(res);
            let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
            _this.$dialogs.alert(errMsg)
            .then(res => {});
            return null;
          }
        }).then((res)=>{
          if(res){
            if (res.status === 200 && res.data.status === "0000") {
              //기존 ARO에 추가 결과 msg
              let msg = '';
              msg += `정기구매 ${targetAro.aro_no}(${targetAro.subject})에 상품을 추가 하였습니다.<br/>`;
              msg += '동일한 상품이 있는 경우 자동으로 수량이 추가됩니다.<br/>';
              msg += '추가한 상품은 해당 정기배송일에 합산하여 배송됩니다.';

              _this.$dialogs.alert(msg).then(res => {});

            }else{
              //console.error(res);
              let errMsg = res.data.message ? res.data.message : ErrMsg.COMM_UNKNOWN_MESSAGE;
              _this.$dialogs.alert(errMsg)
              .then(res => {});
            }
          }
        }).catch((err)=>{
          console.error(err);

          _this.$dialogs.alert(ErrMsg.COMM_UNKNOWN_MESSAGE, {title: ErrMsg.COMM_ERROR_TITLE})
          .then(res => {});

        }).finally(()=>{
          _this.$hideLoading();
        });
      }
    },

    //장바구니 이동
    onClickMoveBasket(){
      let _this = this;

      if(!_this.isLogined()){
        //비 로그인시
        _this.$openLoginConfirm();
        return;
      }

      location.href = `${_this.$aroBasePath}/basket`;
    },

    //상품 클릭
    onClickMoveProductDetail(product, idx){
      let _this = this;

      //GA 전송-상품 목록
      try{
        _this.sendGaProductClick(product, idx, function(){
          location.href=`${_this.$aroBasePath}/detail/${product.pd_id}?ref_title=${_this.gaTitle}`;
        });
      }catch(e){
        //ignore
        console.error(e);
      }
    },

    //GA 전송-상품 목록
    sendGaProductList(){
      let _this = this;

      let gaData = {
        event: 'productList_ARO',
        product: []
      };

      gaData.product = _this.productList.map((prod, idx)=>{
        let retData = {
          name : prod.pd_name_kr,
          id : prod.pd_id,
          price : prod.pd_amt1,
          brand: prod.brandName ? prod.brandName : '',
          category: prod.categoryName ? prod.categoryName : '',
          variant : 'ARO',
          list : _this.gaTitle,
          position : (idx+1)
        };

        return retData;
      });

      _this.$sendAroGA(gaData);
    },

    //GA 전송-상품 클릭
    sendGaProductClick(prod, idx, callback){
      let _this = this;

      let gaData = {
        event: 'productClick_ARO',
        ecommerce: {
          click: {
            actionField: {
              list: _this.gaTitle
            },
            products : [
              {
                name : prod.pd_name_kr,
                id : prod.pd_id,
                price : prod.pd_amt1,
                brand: prod.brandName ? prod.brandName : '',
                category: prod.categoryName ? prod.categoryName : '',
                variant : 'ARO',
                position : (idx+1)
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData, callback);
    },

    //GA 전송-장바구니 클릭
    sendGaProductToCart(prod, qty){
      let _this = this;

      let price = parseInt(""+prod.pd_amt1, 10);

      let gaData = {
        event: 'addToCart_ARO',
        ecommerce: {
          add: {
            currencyCode: 'KRW',
            products : [
              {
                name: prod.pd_name_kr,
                id: prod.pd_id,
                price: price,
                brand: prod.brandName ? prod.brandName : '',
                category: prod.categoryName ? prod.categoryName : '',
                variant : 'ARO',
                quantity: qty
              },
            ]
          }
        }
      };

      _this.$sendAroGA(gaData);
    },

  }
};
</script>
<style>
a.rew19_btnPre, a.rew19_btnNext, a.rew19_basket_oder, a.rew19_aProduct{
  cursor: pointer;
}

.rew19_basket_center{
  max-width: 1100px;
  margin: 0 auto;
}

.rew19_basket_detail li{
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/integration/searchProductList.vue